export default {
  name: 'Payment Service |||| Payment Services',
  subtitle: 'All payment services',
  list: {
    id: 'ID',
    name: 'Name',
    group: 'Group',
    partnerId: 'Partner external ID',
    templateId: 'Template service ID',
    paymentGroupsSetup: 'Setup payment groups',
    operationType: 'Operation type',
    processingFlow: 'Processing flow',
    tags: 'Tags',
  },
  tabs: {
    details: 'Details',
    references: 'Groups',
  },
  show: {
    detailsHeading: 'Service details',
    recordTitle: 'Service',
    referencesHeading: 'List of groups',
  },
  create: {
    title: 'Create new service',
    subtitle: 'Input service details',
  },
  edit: {
    title: 'Edit service',
    subtitle: 'Edit fields and press Save to continue',
  },
  delete: {
    attention: 'Delete service',
    alert: 'Are you sure you want to delete this service? This action is irreversable!',
    success: 'Service has been deleted successfully!',
  },
  fields: {
    id: 'ID',
    name: 'Name',
    templateId: 'Template ID',
    partnerId: 'Partner ID',
    accountId: 'Account ID',
    operationType: 'Operation type',
    category: 'Category',
    description: 'Description',
    instruction: 'Instruction',
    status: 'Status',
    parameterGroups: 'Parameter groups',
    parameters: 'Parameters',
    index: 'Index',
    region: 'Region (deprecated)',
    amount: 'Amount configuration',
    recipientExternalSource: 'Recipient external source configuration',
    processing: 'Processing configuration',
    processingFlow: 'Processing flow',
    processingParameters: 'Processing parameters',
    deal: 'Deal configuration',
    i18n: 'Localization',
    tags: 'Tags',
    additionalProperties: 'Additional properties',
    tagsHelperText: "To add tag input it's name and press Enter",
    fallbackServiceId: 'Fallback services',
    fxRates: 'Direct FX rates',
    approvalTransactionAuthorization: {
      _: 'Approval Business Process',
      REVIEW_INTERNALLY: 'Review internally',
    },
    onBeforeInit: 'Initialization script (before integration request)',
    onBeforeCheck: 'Check script (before integration request)',
    onInit: 'Initialization script (after integration request)',
    onCheck: 'Check script (after integration request)',
    scriptsWarning: 'Change "%{field}" with extra care!',
    invalidJson: 'Invalid JSON format',
    pasteOnInit: 'View script structure example',
    pasteOnCheck: 'View script structure example',
    viewOnBeforeInit: 'View script structure example',
    viewOnBeforeCheck: 'View script structure example',
    scriptExampleTitle: 'Script structure example',
    exampleScript: 'Example script',
    amountConfigurationSection: 'Amount Configuration',
    amountConfigurationEnabled: 'Enable Amount Configuration',
    amountConfig: {
      mode: 'Amount mode',
      singleAmountJson: 'Single amount configuration',
      beneficiaryJson: 'Beneficiary amount configuration',
      remitterJson: 'Remitter amount configuration',
      DEFAULT: 'Default',
      FIXED: 'Fixed',
      SUGGESTED: 'Suggested',
      BENEFICIARY_REMITTER: 'Beneficiary/Remitter',
    },
    beneficiaryConfigurationEnabled: 'Enable Beneficiary Configuration',
    beneficiary: {
      _: 'Beneficiary configuration',
      selection: 'Beneficiary selection',
      DISABLED: 'Disabled',
      MANDATORY: 'Mandatory',
      OPTIONAL: 'Optional',
      allowedTypes: 'Allowed types',
      INDIVIDUAL: 'Individual',
      BUSINESS: 'Business',
      BOTH: 'Both',
      allowedPhoneNumberPrefixes: 'Allowed Phone Number Prefixes',
      allowedCountries: 'Allowed Countries',
      allowedPhoneNumberPrefixesHelperText: 'Input phone number prefix, and press Enter',
      selectionHintTitle: 'Beneficiary selection hint',
      selectionHint: `
Step 1. Beneficiary selection: Choose how beneficiaries are handled:

- 'Disabled': No beneficiary selection is shown.
- 'Mandatory': A beneficiary must be selected.
- 'Optional': Beneficiary selection is allowed but not required.

If 'Mandatory' or 'Optional' is selected, beneficiary management screens are shown as the first stage of the Payment Service.

Step 2. Allowed Types: Select which types of beneficiaries are permitted: Individual, Business, or Both.

Step 3. Allowed Phone Number Prefixes: Specify which phone number prefixes are valid for beneficiaries.

Step 4. Allowed Countries: Choose the countries from which beneficiaries can be selected.

 Available Beneficiaries are filtered by:
- Allowed types,
- Allowed phone number prefixes (if specified),
- Allowed countries (if specified),
- Status 'ACTIVE'.

All other beneficiaries are shown as "Not Available Beneficiaries".

When adding a beneficiary, the available options are limited according to the allowed parameters of the Payment Service.
`,
    },
  },
  references: {
    group: 'Group references',
    addReference: 'Add to group',
    addReferenceDialogTitle: 'Add to group',
    addReferenceLabel: 'Group to reference',
    confirm: 'Confirm',
    deleteReference: 'Delete reference',
    empty: 'This service is not added to any group for a while.',
    createSuccess: 'Service has been added to the group successfully!',
    createFailure: 'Failed to add service to the group.',
    deleteSuccess: 'Service has been removed from the group successfully!',
    deleteFailure: 'Failed to remove service from the group.',
  },
};
